<template>
  <header class="pb-head">
    <div class="ph-text">
      <div v-if="kicker" class="pb-kicker">{{ kicker }}</div>
      <h1 class="pb-title display-font">{{ title }}</h1>
      <p v-if="subtitle || $slots.subtitle" class="pb-body"><slot name="subtitle">{{ subtitle }}</slot></p>
    </div>
    <div v-if="$slots.default" :class="['pb-actions', 'ph-actions', { 'ph-wide-only': wideOnly }]"><slot /></div>
  </header>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: { type: String, required: true },
    kicker: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    // The actions show from 601px up only: on phones the page offers them elsewhere (an editor's SaveBar).
    wideOnly: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
.ph-text{min-width:0}
.ph-actions{flex:0 0 auto}
@media(max-width:600px){.ph-actions{flex:1 1 auto}.ph-wide-only{display:none}}
</style>
